<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p>To Tony and Pat Davey, remembering many travels together, and looking forward to many more</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?3e1b652a